var _rect, _rect2, _rect3, _mask, _path, _path2, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLidOffJarOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 35,
    viewBox: "0 0 22 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.499878,
    y: 7.02826,
    width: 14.0964,
    height: 1.79562,
    rx: 0.5,
    fill: "#3B1F8E",
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.53186,
    y: 5.35071,
    width: 4.03212,
    height: 1.2365,
    rx: 0.5,
    fill: "white",
    stroke: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.85474,
    y: 25.8408,
    width: 7.38686,
    height: 1.2365,
    rx: 0.5,
    fill: "#3B1F8E",
    stroke: "black"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_43_25",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0965 14.0403C15.0965 13.488 14.6488 13.0403 14.0965 13.0403H1.00012C0.447837 13.0403 0.00012207 13.488 0.00012207 14.0403V15.0391C0.00012207 15.4792 0.356868 15.8359 0.796936 15.8359V15.8359C1.21236 15.8359 1.55808 16.1551 1.59121 16.5692L2.28506 25.2422C2.32663 25.7619 2.76051 26.1625 3.28187 26.1625H11.8141C12.3355 26.1625 12.7694 25.7619 12.8109 25.2422L13.5047 16.5695C13.5379 16.1552 13.8837 15.8359 14.2993 15.8359V15.8359C14.7396 15.8359 15.0965 15.479 15.0965 15.0388V14.0403Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0965 14.0403C15.0965 13.488 14.6488 13.0403 14.0965 13.0403H1.00012C0.447837 13.0403 0.00012207 13.488 0.00012207 14.0403V15.0391C0.00012207 15.4792 0.356868 15.8359 0.796936 15.8359V15.8359C1.21236 15.8359 1.55808 16.1551 1.59121 16.5692L2.28506 25.2422C2.32663 25.7619 2.76051 26.1625 3.28187 26.1625H11.8141C12.3355 26.1625 12.7694 25.7619 12.8109 25.2422L13.5047 16.5695C13.5379 16.1552 13.8837 15.8359 14.2993 15.8359V15.8359C14.7396 15.8359 15.0965 15.479 15.0965 15.0388V14.0403Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8109 25.2422L11.8141 25.1625L12.8109 25.2422ZM1.00012 14.0403H14.0965V12.0403H1.00012V14.0403ZM1.00012 15.0391V14.0403H-0.999878V15.0391H1.00012ZM3.28187 25.1625L2.58803 16.4894L0.594397 16.6489L1.28824 25.322L3.28187 25.1625ZM11.8141 25.1625H3.28187V27.1625H11.8141V25.1625ZM12.5079 16.4897L11.8141 25.1625L13.8077 25.322L14.5016 16.6492L12.5079 16.4897ZM14.0965 14.0403V15.0388H16.0965V14.0403H14.0965ZM14.2993 16.8359C15.2919 16.8359 16.0965 16.0313 16.0965 15.0388H14.0965C14.0965 14.9267 14.1873 14.8359 14.2993 14.8359V16.8359ZM14.5016 16.6492C14.4931 16.7546 14.4051 16.8359 14.2993 16.8359V14.8359C13.3624 14.8359 12.5827 15.5558 12.5079 16.4897L14.5016 16.6492ZM11.8141 27.1625C12.8568 27.1625 13.7246 26.3614 13.8077 25.322L11.8141 25.1625L11.8141 25.1625V27.1625ZM1.28824 25.322C1.37139 26.3614 2.23915 27.1625 3.28187 27.1625V25.1625L3.28187 25.1625L1.28824 25.322ZM0.796936 16.8359C0.691004 16.8359 0.602845 16.7545 0.594397 16.6489L2.58803 16.4894C2.51332 15.5556 1.73372 14.8359 0.796936 14.8359V16.8359ZM-0.999878 15.0391C-0.999878 16.0314 -0.195417 16.8359 0.796936 16.8359V14.8359C0.909153 14.8359 1.00012 14.9269 1.00012 15.0391H-0.999878ZM14.0965 14.0403L14.0965 14.0403H16.0965C16.0965 12.9357 15.201 12.0403 14.0965 12.0403V14.0403ZM1.00012 12.0403C-0.104446 12.0403 -0.999878 12.9357 -0.999878 14.0403H1.00012L1.00012 14.0403V12.0403Z",
    fill: "black",
    mask: "url(#path-4-inside-1_43_25)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43_25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 33.5082C13.7615 33.5082 16.0001 31.2696 16.0001 28.5082C16.0001 25.7468 13.7615 23.5082 11.0001 23.5082C8.2387 23.5082 6.00012 25.7468 6.00012 28.5082C6.00012 31.2696 8.2387 33.5082 11.0001 33.5082Z",
    fill: "#0C995E",
    stroke: "#0C995E",
    strokeWidth: 1.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50012 28.5082L10.5001 29.5082L12.5001 27.5082",
    stroke: "white",
    strokeWidth: 1.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_43_25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6788 11.2761C18.4403 11.2761 20.6788 9.03755 20.6788 6.27612C20.6788 3.5147 18.4403 1.27612 15.6788 1.27612C12.9174 1.27612 10.6788 3.5147 10.6788 6.27612C10.6788 9.03755 12.9174 11.2761 15.6788 11.2761Z",
    fill: "#FFBC0E",
    stroke: "#FFBC0E",
    strokeWidth: 1.28623,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6787 4.27612V6.27612",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6787 8.27606H15.6861",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43_25"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 13,
    fill: "white",
    transform: "translate(5.00012 22)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_43_25"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(9.67871 0.276062)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLidOffJarOn);
export default __webpack_public_path__ + "static/media/lidOffJarOn.df33c6a2523aaae35568e3d289d56e9f.svg";
export { ForwardRef as ReactComponent };